function signInConstraints() {
  return {
  email: { presence: {message: "Required"},
           email: {message: "Invalid email format"}},
  password: {
    presence: {message: "Required"},
    length: {
      minimum: 6,
      message: "Min. 6 characters"
    }
  }};
}

function emailConstraints() {
  return { email: { presence: {message: "Required"},
           email: {message: "Invalid email format"}}
         };
}

function signUpConstraints() {
  return {
    name: { presence: {message: "Required"}},
    email: { presence: {message: "Required"},
           email: {message: "Invalid email format"}},
    password: {
      presence: {message: "Required"},
      length: {
        minimum: 6,
        message: "Min. 6 characters"
      }
    }
  };
}

function otpConstraints() {
  return {
    otp: { presence: {message: "Required"},
      length: {
        is: 5,
        message: "Invalid OTP"
      }
    }
  }
}

function resetPasswordConstraints() {
  return {
    password: {
      presence: {message: "Required"},
      length: {
        minimum: 6,
        message: "Min. 6 characters"
      }
    },
    confirmPassword: {
      presence: {message: "Required"},
      length: {
        minimum: 6,
        message: "Min. 6 characters"
      }
    }
  }
}

function passwordEqualityConstraints() {
  return {
    confirmPassword: {
      equality: {
        attribute: "password",
        message: "Passwords do not match",
      }
    }
  }
}

  export {
    signInConstraints,
    signUpConstraints,
    otpConstraints,
    resetPasswordConstraints,
    passwordEqualityConstraints,
    emailConstraints
  }


// WEBPACK FOOTER //
// ./app/javascript/util/validation_constraints.js